enum ShopEntryPoints {
  getSelect = '/api/select/shop',
  checkOpening = '/api/shop/sales/check-open/{shopId}',
  notifyManagerValidatedInventory = '/api/shop/seller/alerte-shop-inventory/{id}/{deposit}',
}

export default ShopEntryPoints;
